var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "preloader", class: _vm.isAbsolute ? "is-absolute" : "" },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loader" }, [
      _c("img", {
        staticClass: "loader-outer",
        attrs: { src: "/public/img/loader-outer.png", alt: "" },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "loader-inner",
        attrs: { src: "/public/img/loader-inner.png", alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }